var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7771 1.66602C12.339 1.66602 11.9835 2.02157 11.9835 2.45967C11.9835 2.89776 12.339 3.25332 12.7771 3.25332H15.6231L9.04139 9.83504C8.73147 10.145 8.73147 10.6474 9.04139 10.9573C9.19655 11.1125 9.39935 11.1898 9.60252 11.1898C9.8057 11.1898 10.0085 11.1125 10.1637 10.9573L16.7454 4.37559V7.22157C16.7454 7.65967 17.1009 8.01522 17.539 8.01522C17.9771 8.01522 18.3327 7.65967 18.3327 7.22157V2.45967C18.3327 2.02157 17.9771 1.66602 17.539 1.66602H12.7771ZM4.04697 2.45967C2.73387 2.45967 1.66602 3.52752 1.66602 4.84062V15.9517C1.66602 17.2648 2.73387 18.3327 4.04697 18.3327H15.1581C16.4712 18.3327 17.539 17.2648 17.539 15.9517V11.1898C17.539 10.7517 17.1835 10.3962 16.7454 10.3962C16.3073 10.3962 15.9517 10.7517 15.9517 11.1898V15.9517C15.9517 16.3894 15.5958 16.7454 15.1581 16.7454H4.04697C3.60927 16.7454 3.25332 16.3894 3.25332 15.9517V4.84062C3.25332 4.40292 3.60927 4.04697 4.04697 4.04697H8.80887C9.24697 4.04697 9.60252 3.69141 9.60252 3.25332C9.60252 2.81522 9.24697 2.45967 8.80887 2.45967H4.04697Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/link-white.5228d68cb9697e256bf7c8270e4eb6a3.svg";
export { ForwardRef as ReactComponent };